import type { FaireProductEntity } from "../../entity_types/product";

export const atc_updated_moma_4: FaireProductEntity = {
  token: "atc_updated_moma_4",
  type: "product",
  name: "Creative Espresso Cups Set of 6",
  brandName: "MoMA Design Store",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/5a18040f5b86dd8f93ebb07cbe640653b9299ac578ad273d1061eda0bfb94c3d.webp",
  priceDollars: 45,
  msrpDollars: 55,
  description: "Memphis-style porcelain espresso cups.",
  tags: ["home", "design"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
